// @core/api/endpoints/admin/update_admin_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AdminSettingsResponse,
  UpdateAdminSettingsRequest,
} from '../../../types/admin';

const BASE_PATH = '/admin';

/**
 * Update admin settings
 * Updates platform-level administrative settings. Changes may affect all users and services across the platform.
 */
export async function UpdateAdminSettings(
  data: UpdateAdminSettingsRequest,
  options?: RequestOptions
): Promise<AdminSettingsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/admin/settings`;
  const requestOptions = options;
  return client.put<AdminSettingsResponse>(requestPath, data, requestOptions);
}
